import { render, staticRenderFns } from "./settlementDetailDialog.vue?vue&type=template&id=5008dbd6"
import script from "./settlementDetailDialog.vue?vue&type=script&lang=js"
export * from "./settlementDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports